import { render } from "./preset.vue?vue&type=template&id=5684de7a&scoped=true&lang=pug"
import script from "./preset.vue?vue&type=script&lang=js"
export * from "./preset.vue?vue&type=script&lang=js"

import "./preset.vue?vue&type=style&index=0&id=5684de7a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5684de7a"]])

export default __exports__